import React from 'react';
export const StatsBar = () => {
  return <div className="bg-navy-900 border-y border-white/5 py-8 md:py-10 relative overflow-hidden" data-id="element-328">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-pink-500/5 to-transparent" data-id="element-329"></div>
      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-330">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 text-center" data-id="element-331">
          {[{
          value: '+1.200',
          label: 'profesionales confían'
        }, {
          value: '4',
          label: 'Tomos listos'
        }, {
          value: '4',
          label: 'Bonos incluidos'
        }, {
          value: '4.9/5',
          label: 'calificación ⭐'
        }].map((stat, i) => <div key={i} className="relative group" data-id="element-332">
              <div className="text-3xl md:text-5xl font-black text-pink-400 mb-2 drop-shadow-[0_0_15px_rgba(236,72,153,0.3)] group-hover:scale-110 transition-transform duration-500 font-[Montserrat,_sans-serif]" data-id="element-333">
                {stat.value}
              </div>
              <div className="text-[10px] md:text-xs text-gray-300 uppercase font-black tracking-[0.2em] opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-334">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};